import { DragLayerMonitorProps } from '@minoru/react-dnd-treeview';
import React, { useMemo } from 'react';
import { DocModel } from 'src/@types/docs';
import { CustomNode } from './CustomNode';
import type { TreeItem } from './types';
import { getAllParentIds } from './utils';

type Props = {
  monitorProps: DragLayerMonitorProps<DocModel>;
  tree: TreeItem[];
};

export const CustomDragPreview: React.FC<Props> = ({ monitorProps, tree }) => {
  const { item } = monitorProps;
  if (!item) return null;

  const subTree = useMemo(() => {
    return tree
      .filter(
        (node) =>
          node.id === item.id ||
          getAllParentIds(tree, String(node.id)).includes(String(item.id)),
      )
      .map<TreeItem & { depth: number }>((node) => {
        const depth =
          node.id === item.id
            ? ((item as any).depth ?? 0)
            : getAllParentIds(tree, String(node.id)).length;
        return { ...node, depth };
      });
  }, [tree, item.id, item]);

  return (
    <div>
      {subTree.map((node) => (
        <CustomNode
          key={node.id}
          node={node}
          depth={node.depth}
          isOpen={true}
          onToggle={() => {}}
        />
      ))}
    </div>
  );
};
